(function () {
    'use strict';

    angular.module('ib-bids-slider-module', [])
        .directive('moveCursorToEnd',moveCursorToEnd);

    moveCursorToEnd.$inject = ['$timeout', '$window'];

    function moveCursorToEnd ($timeout, $window) {
        return {
            restrict: 'A',
            link: link
        };

        function link (scope, element) {
            element.on('click', () => {
                const val = element.val();
                element.val(val); // Volvemos a establecer el valor para mantenerlo
                element[0].setSelectionRange(val.length, val.length); // Movemos el cursor al final del campo
            });
        }
    }
})();